import { listingByIdRef } from './listings';
export var listingViewsRef = function listingViewsRef(listingId) {
  return listingId ? listingByIdRef(listingId).collection('views') : null;
};
export var listingViewByIdRef = function listingViewByIdRef(listingId, viewId) {
  return listingId && viewId ? listingViewsRef(listingId).doc(viewId) : null;
};